import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-row gap-sm justify-end" }

import { onBeforeMount} from 'vue';
import ActionColumn from '@/core/components/resource/ActionColumn';
import FaIcon from '@/core/components/FaIcon.vue';
import AppButton from '@/core/components/form/AppButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionColumn',
  props: {
    column: {},
    row: {}
  },
  setup(__props: any) {

const props = __props;

onBeforeMount(() => {
	props.column.filterItems();
	props.column.addWidthClass();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.column.items, (item, i) => {
      return (_openBlock(), _createElementBlock("span", { key: i }, [
        (item.isLink())
          ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: item.to(_ctx.row),
              class: _normalizeClass(item.getClass())
            }, {
              default: _withCtx(() => [
                _createVNode(FaIcon, {
                  icon: item.config.icon,
                  weight: item.iconWeight()
                }, null, 8, ["icon", "weight"])
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          : (_openBlock(), _createBlock(AppButton, {
              key: 1,
              icon: item.config.icon,
              "icon-weight": "s",
              onClick: ($event: any) => (item.trigger(_ctx.row)),
              variant: item.getClass(),
              seamless: true
            }, null, 8, ["icon", "onClick", "variant"]))
      ]))
    }), 128))
  ]))
}
}

})